const AVATAR = {
  QUALITY: 0.5,
  FORMAT: 'image/jpeg',
};

const MODAL = {
  MOBILE: {
    WIDTH: '100%',
    HEIGHT: '100%',
  },
  DESKTOP: {
    WIDTH: 688,
    HEIGHT: 'auto',
  },
};

const CONFIG = {
  THUMBNAIL_SIZE: 250,
  MODAL,
  AVATAR,
} as const;

export default CONFIG;
